import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "facebook-campaign-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-header d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "trezo-card-subtitle" }
const _hoisted_5 = { class: "trezo-card-header-menu position-relative" }
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = { class: "chart position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "trezo-card-title" }, [
          _createElementVNode("h5", { class: "mb-0 fw-semibold" }, "Facebook Campaign Overview"),
          _createElementVNode("p", { class: "fw-normal" }, "Track campaign success at a glance!")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("select", {
              class: "form-select month-select form-control",
              "aria-label": "Default select example",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTimeRangeChange && _ctx.handleTimeRangeChange(...args)))
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("option", { value: "This Day" }, "This Day", -1),
              _createElementVNode("option", { value: "This Week" }, "This Week", -1),
              _createElementVNode("option", { value: "This Month" }, "This Month", -1),
              _createElementVNode("option", { value: "This Year" }, "This Year", -1)
            ]))], 32)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "title fw-medium text-black d-block position-relative" }, [
          _createElementVNode("i", { class: "ri-bookmark-line" }),
          _createTextVNode(" Summer Sale Boost ")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "line",
                height: "298",
                options: _ctx.chartOptions,
                series: _ctx.series
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"items\" data-v-666d72c5><div class=\"item d-flex\" data-v-666d72c5><div class=\"dot bg-primary rounded-circle\" data-v-666d72c5></div><div data-v-666d72c5><span class=\"d-block fw-medium text-black\" data-v-666d72c5> 45,000 </span><span class=\"b-block mt-0 mb-0 text-xs\" data-v-666d72c5> Impressions </span></div></div><div class=\"item d-flex\" data-v-666d72c5><div class=\"dot bg-success rounded-circle\" data-v-666d72c5></div><div data-v-666d72c5><span class=\"d-block fw-medium text-black\" data-v-666d72c5> 4,200 </span><span class=\"b-block mt-0 mb-0 text-xs\" data-v-666d72c5> Clicks </span></div></div><div class=\"item d-flex\" data-v-666d72c5><div class=\"dot bg-orange rounded-circle\" data-v-666d72c5></div><div data-v-666d72c5><span class=\"d-block fw-medium text-black\" data-v-666d72c5> 9.3% </span><span class=\"b-block mt-0 mb-0 text-xs\" data-v-666d72c5> CTR </span></div></div><div class=\"item d-flex\" data-v-666d72c5><div class=\"dot bg-purple rounded-circle\" data-v-666d72c5></div><div data-v-666d72c5><span class=\"d-block fw-medium text-black\" data-v-666d72c5> $5.50 </span><span class=\"b-block mt-0 mb-0 text-xs\" data-v-666d72c5> Cost Per Conversion </span></div></div></div>", 1))
        ])
      ])
    ])
  ]))
}